export const handleForSaleLandingRouting = (url: string) => {
    const isForSaleLanding = url === '/for-sale/';

    if (isForSaleLanding) {
        window.location.assign(url);
    }
};
